var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("店铺管理")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("店铺管理")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              { attrs: { inline: true, id: "search", size: "small" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "店铺名称" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入店铺名称" },
                      model: {
                        value: _vm.search.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "name", $$v)
                        },
                        expression: "search.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "店铺编码" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入店铺编码" },
                      model: {
                        value: _vm.search.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "code", $$v)
                        },
                        expression: "search.code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "所属平台" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择平台", clearable: "" },
                        model: {
                          value: _vm.search.platformId,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "platformId", $$v)
                          },
                          expression: "search.platformId",
                        },
                      },
                      _vm._l(_vm.platformList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择状态", clearable: "" },
                        model: {
                          value: _vm.search.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "status", $$v)
                          },
                          expression: "search.status",
                        },
                      },
                      _vm._l(_vm.dictionaries.enable_status, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "类目" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.categoryList,
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.onChangeCategory },
                      model: {
                        value: _vm.search.classId,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "classId", $$v)
                        },
                        expression: "search.classId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "h3",
            { staticClass: "data-list-title" },
            [
              _vm._v(" 数据列表 "),
              _vm.parArray.indexOf("addStore") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.showDialog("新增", "add")
                        },
                      },
                    },
                    [_vm._v("新增")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("lb-table", {
            attrs: {
              column: _vm.column,
              data: _vm.shopList,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "shop-dialog",
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: "30%",
            "append-to-body": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "店铺名称", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            maxlength: "20",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "店铺编码", prop: "code" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            maxlength: "6",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "code", $$v)
                            },
                            expression: "form.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属平台", prop: "platformId" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择所属平台",
                              size: "mini",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.platformId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "platformId", $$v)
                              },
                              expression: "form.platformId",
                            },
                          },
                          _vm._l(_vm.platformList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属分类", prop: "classId" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.categoryList,
                            placeholder: "请选择所属分类",
                            size: "mini",
                            filterable: "",
                            clearable: "",
                          },
                          on: { change: _vm.onChangeClassId },
                          model: {
                            value: _vm.form.classId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "classId", $$v)
                            },
                            expression: "form.classId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "序号", prop: "sort" } },
                      [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.form.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sort", _vm._n($$v))
                            },
                            expression: "form.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.dialog.type === "add"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "状态", prop: "status" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "status", $$v)
                                  },
                                  expression: "form.status",
                                },
                              },
                              _vm._l(
                                _vm.dictionaries.enable_status,
                                function (item) {
                                  return _c("el-radio", {
                                    key: item.dictId,
                                    attrs: {
                                      value: item.dictId,
                                      label: item.dictName,
                                      name: item.dictId,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.dialogConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }